import { Injectable } from "@angular/core";
import { AngularFirestore, DocumentReference } from "@angular/fire/firestore";
import { Product } from "../product/product";
import { Observable, Subscription } from "rxjs";
import { Venue } from "../models/venue";
import { VenueApi, TimeframeSetting } from "../api/venue.api";
import { ProductFilterService } from "./filter.service";
import { CalendarEventBuilder } from "../builders/calendar-event.builder";
import { CalendarEvent } from "../models/calendar-event";
import { ProductBuilder } from "../product/product.builder";

@Injectable({
  providedIn: "root"
})
export class VenueService {
  public api: VenueApi;
  public venues$: Observable<Venue[]>;

  public venues: Venue[];

  public searchResults: Venue[];
  public searchText: string;
  public cache: {} = {};
  public venue$: Observable<Venue>;
  public products$: Observable<Product[]>;
  public current: Venue;
  public products: Product[];
  public filter: ProductFilterService;
  public subscription: Subscription;

  public productBuilder: ProductBuilder;
  public editProduct: Product = null;

  public eventBuilders: CalendarEventBuilder[];
  public editEvents: CalendarEvent[];

  constructor(private db: AngularFirestore) {
    this.filter = new ProductFilterService();
    this.api = new VenueApi(this.db);
  }
  async search(searchText: string) {
    this.searchText = searchText;
    this.searchResults = this.venues
      .filter(venue =>
        venue.name.toLowerCase().includes(this.searchText.toLowerCase())
      )
      .sort((a, b) => (a.name < b.name ? -1 : 1));
    for (var i = 0; i < this.searchResults.length; i++) {
      let name = this.searchResults[i].name;
      let isCached = Object.keys(this.cache).includes(name);
      isCached
        ? (this.searchResults[i].passes = this.cache[name])
        : await this.api.countActivePasses(this.searchResults[i]).then(num => {
            this.cache[name] = num;
            this.searchResults[i].passes = num;
          });
    }
  }

  changeVenue(venue: Venue) {
    this.current = venue;
    if (this.subscription != null) this.subscription.unsubscribe();

    this.products$ = this.api.getProducts(venue);

    this.subscription = this.products$.subscribe(async products => {
      this.products = products;
      products.map(async product => await this.getEvents(product));
      this.filter.next(products);
    });
  }

  async getEvents(product: Product) {}

  //ONLY CALL THIS METHOD ON THE OWNER SIDE
  async getAccessibleVenues(cities: string[], venues: string[]) {
    let v = [];
    for (var i = 0; i < cities.length; i++)
      v = v.concat(await this.api.getVenuesForCity(cities[i]));
    for (var i = 0; i < venues.length; i++)
      v.push(await this.api.get(venues[i]));
    this.venues = v;
    return;
  }

  //ONLY CALL THIS WHEN AN ADMIN LOGS IN
  getAllVenues() {
    this.venues$ = this.api.getAll();
    this.venues$.subscribe(venues => {
      this.venues = venues;
    });
  }

  activePasses() {
    if (this.products == null) return 0;
    return this.products.reduce((acc, product) => {
      return acc + (product.isActive ? 1 : 0);
    }, 0);
  }

  initBuilder(product?: Product) {
    this.productBuilder = new ProductBuilder();
    if (product != null) {
      this.productBuilder.edit(product);
      this.editProduct = product;
    } else {
      this.editProduct = null;
    }
  }

  public addProduct = (product: Product): Promise<DocumentReference> =>
    this.api.addProduct(product);
    
  public updateProduct = (product: Product): Promise<void> =>
    this.api.updateProduct(product);

  public addEventsToProduct(productReference: DocumentReference, events: CalendarEvent[]) {
    this.api.addEventsToProduct(productReference, events);
  }
}
